export default values => {
  if (!values.name) return { name: 'Complete el nombre del tratamiento' };
  else return {};
};
